@if (hasFilters) {
  <button
    class="clear-all-filters-btn"
    type="button"
    (click)="clearFilters()"
  >
    {{ "EVENTS.FILTERS.CLEAR_ALL" | translate }}
  </button>
}
